import { createAction } from '@reduxjs/toolkit'

import actionTypes from './actionTypes'

// Fetch vessels (with pagination and search)
export const requestVessels = createAction(
  actionTypes.REQUEST_VESSELS,
  (page = 1, pageSize = 10, searchQuery = '') => ({
    payload: { page, pageSize, searchQuery },
  })
)

export const setRequestingVessels = createAction(
  actionTypes.SET_REQUESTING_VESSELS
)

export const vesselsRequestSuccessful = createAction(
  actionTypes.VESSELS_REQUEST_SUCCESSFUL
)

export const vesselsRequestUnsuccessful = createAction(
  actionTypes.VESSELS_REQUEST_UNSUCCESSFUL
)

// Fetch single vessel
export const requestVessel = createAction(
  actionTypes.REQUEST_VESSEL,
  imoNumber => ({
    payload: { imoNumber },
  })
)

export const setRequestingVessel = createAction(
  actionTypes.SET_REQUESTING_VESSEL
)

export const vesselRequestSuccessful = createAction(
  actionTypes.VESSEL_REQUEST_SUCCESSFUL
)

export const vesselRequestUnsuccessful = createAction(
  actionTypes.VESSEL_REQUEST_UNSUCCESSFUL
)

// Pagination and search
export const setVesselPage = createAction(actionTypes.SET_VESSEL_PAGE)

export const setVesselPageSize = createAction(actionTypes.SET_VESSEL_PAGE_SIZE)

export const setVesselSearchQuery = createAction(
  actionTypes.SET_VESSEL_SEARCH_QUERY
)

// Unified save vessel details (following arrival/departure pattern)
export const saveVesselDetails = createAction(
  actionTypes.SAVE_VESSEL_DETAILS,
  ({ onError, onSuccess, payload, type }) => ({
    payload: {
      onError,
      onSuccess,
      payload,
      type,
    },
  })
)

export const setRequestingSaveVesselDetails = createAction(
  actionTypes.SET_REQUESTING_SAVE_VESSEL_DETAILS,
  isSaving => ({ payload: isSaving })
)

export const setSaveVesselDetailsError = createAction(
  actionTypes.SET_SAVE_VESSEL_DETAILS_ERROR,
  error => ({ payload: error })
)

// Export vessel
export const exportVessel = createAction(actionTypes.EXPORT_VESSEL, id => ({
  payload: { id },
}))
